import React, { useState } from 'react'
import './TravelFinished.min.css'


interface Note {
  id: number;
  name: string;
  isDone: number;
}


interface Props {
  note: Note;
  

}


const NotesTravelEnd: React.FC<Props> = ({ note }) => {

  return (

    <div className='list'>
      <div className='done'>

        {note.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true} readOnly></input>
            <s className='text'> {note.name} </s>
          </span>
        ) : (
          <span>
            <input type='checkbox' checked={false} readOnly></input>
            <span className='text'> {note.name}</span>
          </span>
        )
        }

      </div>
    </div>
   
  )
}

export default NotesTravelEnd